import {
  FC,
  useState,
  ReactNode,
  MutableRefObject,
  memo,
} from 'react';
// 组件
import { Table } from 'antd';
// 方法
import { getTotalInfo } from './util';
// 常量
import { EditMainSubTableColumnType, BaseTotalTableProps } from '../../interface';
import { TABLE_COLUMN_EMPTY } from '../../../constants/constant';
import './style.less';

interface TotalTableAction {
  onChange: (tableData: any[]) => void;
}
export type TotalTableActionType = TotalTableAction | undefined;
interface TotalTableProps extends BaseTotalTableProps {
  /** 列配置 */
  columns?: EditMainSubTableColumnType[];
  /** 对象句柄 */
  actionRef: MutableRefObject<TotalTableActionType>;
}

const TotalTable: FC<TotalTableProps> = memo(props => {
  const {
    columns,
    totalKeys,
    totalIndex,
    totalText,
    actionRef,
    formatTotalData,
  } = props;
  const [totalData, setTotalData] = useState<any>({});
  const handleChange = (tableData: any[]) => {
    const newTotalData = formatTotalData ? formatTotalData(tableData) : getTotalInfo(totalKeys, tableData);
    setTotalData(newTotalData);
  };
  const renderValue = (
    column: EditMainSubTableColumnType,
  ): ReactNode => {
    const { dataIndex } = column;
    if (typeof dataIndex === 'string') {
      return totalData[dataIndex] !== undefined
        ? totalData[dataIndex]
        : TABLE_COLUMN_EMPTY;
    }
    return TABLE_COLUMN_EMPTY;
  };
  actionRef.current = {
    onChange: handleChange,
  };
  return (
    <Table.Summary.Row className="yb-main-edit-total-row">
      {columns?.map((column, index) => {
        const { render, ellipsis, children, ...resColumnProps } = column;
        if (Array.isArray(children) && children.length) {
          return children.map((col, key) => {
            return (
              <Table.Summary.Cell key={key} index={index + key + 101} align={col.align} {...resColumnProps}>
                {renderValue(col)}
              </Table.Summary.Cell>
            );
          });
        }
        if (index === totalIndex) {
          return (
            <Table.Summary.Cell key={index} index={index} {...resColumnProps}>{totalText}</Table.Summary.Cell>
          );
        }
        return (
          <Table.Summary.Cell key={index} index={index} align={column.align} {...resColumnProps}>
            {renderValue(column)}
          </Table.Summary.Cell>
        );
      })}
    </Table.Summary.Row>
  );
});

TotalTable.defaultProps = {
  totalIndex: 0,
  totalText: '合计',
};

export default TotalTable;